import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.open()
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")

    // Clear the turbo frame content
    this.element.parentElement.textContent = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
